import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
const NumberInputStyles = styled.input.withConfig({
  displayName: "IntInputField__NumberInputStyles",
  componentId: "sc-xlou8a-0"
})(["width:4em;"]);
export const IntInputField = ({
  disabled,
  style,
  onlyPositive,
  value,
  onChange
}) => {
  const [override, setOverride] = useState(null);
  useEffect(() => {
    if (value !== 0) {
      setOverride(null);
    }
  }, [value, onlyPositive]);

  const set = e => {
    let stringValue = e.target.value;

    if (stringValue.startsWith("-") && onlyPositive) {
      stringValue = "";
    }

    if (stringValue === "" || stringValue === "-") {
      setOverride(stringValue);
    } else {
      setOverride(null);
    }

    let intValue = parseInt(stringValue) || 0;

    if (onlyPositive) {
      intValue = Math.max(0, intValue);
    }

    onChange(intValue);
  };

  const displayValue = override !== null ? override : Number.isInteger(value) ? value.toString() : "";
  const min = onlyPositive ? 0 : undefined;
  return /*#__PURE__*/React.createElement(NumberInputStyles, {
    disabled: disabled,
    style: style,
    type: "number",
    min: min,
    value: displayValue,
    onChange: set
  });
};